import { getCaptchaInfo } from '@/services/app';

const geetestMixin = {
  data() {
    return {
      geetestObj: null,
    };
  },
  methods: {
    async initGeetest() {
      const data = await getCaptchaInfo();
      window.initGeetest({
        gt: data.data.gt,
        challenge: data.data.challenge,
        offline: !data.data.success,
        new_captcha: true,
        product: 'bind',
      }, (captchaObj) => {
        if (this.geetestObj) this.geetestObj.destroy();
        this.geetestObj = captchaObj;
        captchaObj.onReady(() => {
          if (typeof this.onGeetestReady === 'function') {
            this.onGeetestReady();
          }
        }).onSuccess(() => {
          if (typeof this.onGeetestSuccess === 'function') {
            this.onGeetestSuccess(captchaObj.getValidate());
          }
        }).onClose(() => {
          if (typeof this.onGeetestClose === 'function') {
            this.onGeetestClose();
          }
        }).onError((err) => {
          console.log('onError', err);
        });
      });
    },
    verifyGeetest() {
      this.geetestObj.reset();
      this.geetestObj.verify();
    },
  },
  created() {
    this.$nextTick(() => {
      this.initGeetest();
    });
  },
  beforeDestroy() {
    if (this.geetestObj) this.geetestObj.destroy();
  },
};

export default geetestMixin;
